import htm from 'htm';
import { h } from 'preact';
export default htm.bind(h);
